export const trustBadges = {
  neasc: "Accrédité NEASC",
  xunta: "Autorisée par la Xunta de Galice",
  trilingual: "Anglais 40-50% | ES | GL",
  ages: "3-12 ans · Petits effectifs"
};
